module.exports = __webpack_public_path__ + "static/media/refresh_effect.fed7943d.png";